import "./css/ChartLoader.css";

const BarChartLoader = () => {
  const labels = ["-", "-", "-", "-", "-"];

  return (
    <div className="chart-skeleton">
      {labels.map((label, index) => (
        <div key={index} className="chart-skeleton-column">
          <div className={`chart-skeleton-bar bar-${index + 1}`} />
          <div className="chart-skeleton-label">{label}</div>
        </div>
      ))}
    </div>
  );
};

export default BarChartLoader;
